module.exports = __webpack_public_path__ + "static/media/AP_ES_Z2.4e2e4a3f.png";